import type { DelegationAccept, DelegationMaxRole, DelegationPropose } from '@detect/shared';
import { api, withTenant } from './api';

/** Cross-tenant management delegation (#16; docs/architecture/delegation.md). Every call acts FOR the
 *  active tenant; the API requires a direct account_admin membership of it. */
export interface DelegationView {
  id: string;
  /** Which side the active tenant is. */
  side: 'grantor' | 'grantee' | null;
  counterpartTenantId: string;
  counterpartName: string | null;
  initiatedBy: 'grantor' | 'grantee';
  status: 'pending' | 'active' | 'declined' | 'revoked';
  maxRole: DelegationMaxRole | null;
  clientIds: string[] | null;
  proposedAt: string;
  decidedAt: string | null;
  revokedAt: string | null;
  revokedBySide: 'grantor' | 'grantee' | null;
  /** Who has to act next on a pending proposal. */
  awaiting: 'you' | 'them' | null;
}

export const delegationService = {
  list: (tenantId: string): Promise<DelegationView[]> =>
    api.get<DelegationView[]>(withTenant('/delegations', tenantId)),
  propose: (tenantId: string, input: DelegationPropose): Promise<{ id: string; status: string }> =>
    api.post(withTenant('/delegations', tenantId), input),
  accept: (tenantId: string, id: string, terms: DelegationAccept = {}): Promise<DelegationView> =>
    api.post(withTenant(`/delegations/${id}/accept`, tenantId), terms),
  decline: (tenantId: string, id: string): Promise<DelegationView> =>
    api.post(withTenant(`/delegations/${id}/decline`, tenantId), {}),
  revoke: (tenantId: string, id: string): Promise<DelegationView> =>
    api.post(withTenant(`/delegations/${id}/revoke`, tenantId), {}),
};
